import { appStoreLink, playStoreLink } from "../../utils/appLinks";
import classes from "./Col4.module.css";

function Col4() {
  return (
    <div className={classes.container}>
      <div className={classes.wrapper}>
        <span className={classes.eyebrow}>Get the app</span>

        <h1>
          Pay with ease and book in{" "}
          <span className={classes.highlight}>seconds</span> — all from one
          simple app.
        </h1>

        <p>
          Rides, deliveries and gift cards, all in your pocket. Download
          Sprinterwave for free today.
        </p>

        <div className={classes.download_}>
          <a
            href={playStoreLink}
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src="/images/playstore_.webp" alt="Get it on Google Play" />
          </a>
          <a href={appStoreLink} target="_blank" rel="noopener noreferrer">
            <img src="/images/appstore_.webp" alt="Download on the App Store" />
          </a>
        </div>

        <div className={classes.floatingBadge}>
          <span className={classes.stars}>★★★★★</span>
          Rated 4.8 by 10k+ riders
        </div>
      </div>
    </div>
  );
}

export default Col4;